<nz-header class="table-header">
  <div class="table-header-row margin-lr">
    <div class="table-header-cell">
      {{ "Functional Gait Assessment" | translate }}
    </div>
  </div>
</nz-header>

@if (!isLoading && pages.length > current) {
  <form
    style="margin-bottom: 10em"
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
  >
    <app-fga-questions
      [elements]="pages[current].elements"
      [pageTitle]="pages[current].title"
      [formGroup]="formGroup"
      [readonlyMode]="readonlyMode"
    />

    <div class="steps-action">
      <div class="right-actions" *hasAddPermissions="['a-sqa']">
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzDanger
            class="cancel-btn"
            type="button"
            (click)="revertForm()"
            [disabled]="!hasChanges"
          >
            <span>{{ "Revert" | translate }}</span>
          </button>
        }
        @if (!readonlyMode && formInitialized && (isInpatientView() || isEOC())) {
          <button
            nz-button
            nzType="primary"
            type="submit"
            [disabled]="!hasChanges"
          >
            <span>{{ "Submit" | translate }}</span>
          </button>
        }
      </div>
    </div>
  </form>
}

@if (isLoading) {
  <nz-spin [nzSpinning]="true" nzSize="large"></nz-spin>
}
